import { useFormContext } from 'react-hook-form'

import { ConfigureProductFormState } from '../types'

/**
 * Whether the product form shows its validation errors: only after the first
 * Add attempt.
 */
export default function useShowProductValidationErrors() {
  const { formState } = useFormContext<ConfigureProductFormState>()

  return formState.submitCount > 0
}
